import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchTypeaheadProjects, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

function selectFilterOption() {
    return true;
}

class ProjectTypeahead extends Component {
    static propTypes = {
        labelId: PropTypes.string,
        fetchTypeaheadProjects: PropTypes.func,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        osVersions: PropTypes.array.isRequired, // eslint-disable-line
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        isMulti: PropTypes.bool,
        animatedPlaceholder: PropTypes.bool,
        renderSectionTitle: PropTypes.func,
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        labelId: 'project',
        suggestions: [],
        renderMultiSuggestion
    };

    handleSuggestionsFetchRequested = term => {
        this.props.fetchTypeaheadProjects(ProjectTypeahead.name, { term });
    };

    render() {
        const {
            required = false,
            disabled,
            error,
            labelId,
            isMulti,
            animatedPlaceholder,
            suggestions,
            value,
            clearTypeahed,
            onChangeSuggestion,
            renderSectionTitle,
            renderMultiSuggestion,
            t
        } = this.props;

        const options = (Array.isArray(suggestions) ? suggestions : []).map(project => ({
            label: project.name,
            value: project.id
        }));

        return (
            <MultiTypeahead
                required={required}
                disabled={disabled}
                error={error}
                titleId={labelId}
                isMulti={isMulti}
                animatedPlaceholder={animatedPlaceholder}
                options={options}
                value={value}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                handleSuggestionsClearRequested={clearTypeahed}
                onChangeSuggestion={onChangeSuggestion}
                selectFilterOption={selectFilterOption}
                formatGroupLabel={renderSectionTitle}
                formatOptionLabel={renderMultiSuggestion}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead, infrastructure }) => ({
    suggestions:
        typeahead.source === ProjectTypeahead.name ? typeahead.list : ProjectTypeahead.defaultProps.suggestions,
    osVersions: infrastructure.osVersions
});

export default connect(mapStateToProps, {
    fetchTypeaheadProjects,
    clearTypeahed
})(ProjectTypeahead);
